module.exports = __webpack_public_path__ + "annualreview2017/static/img/communities-environment-1@0,5x.1ba6e20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/circles/focus/communities-environment-1@0,5x.jpg
// module id = 703
// module chunks = 0